import { CheckCircleFilled } from '@ant-design/icons'
import { Stack, Typography } from '@sureco/design-system'
import { Divider, Tag } from '@surecompanies/core_components'
import React from 'react'
import { DEMO_PRESETS } from '../constants'

export default function DemoPresetsSummary() {
  return (
    <Stack space={20}>
      <Typography size={13} color="#595959">
        The following settings are automatically applied to every demo customer.
        No input is required — this is shown for your reference only.
      </Typography>
      {DEMO_PRESETS.map((section, sIdx) => (
        <Stack key={sIdx} space={10}>
          <Typography size={14} style={{ fontWeight: 600, color: '#003146' }}>
            {section.title}
          </Typography>
          <Stack space={6}>
            {section.items.map((item, iIdx) => (
              <Stack key={iIdx} direction="row" space={8} align="flex-start">
                <CheckCircleFilled
                  style={{ color: '#52c41a', marginTop: 2, flexShrink: 0 }}
                />
                <Stack space={2}>
                  <Stack direction="row" space={8} align="center">
                    <Typography size={13} style={{ fontWeight: 500 }}>
                      {item.label}
                    </Typography>
                    <Tag
                      color={
                        item.value === 'OFF' || item.value === 'HIDDEN'
                          ? 'red'
                          : item.value === 'ON' || item.value === 'TRUE'
                            ? 'green'
                            : 'blue'
                      }
                      style={{ fontSize: 11 }}
                    >
                      {item.value}
                    </Tag>
                  </Stack>
                  {item.description && (
                    <Typography size={12} color="#8c8c8c">
                      {item.description}
                    </Typography>
                  )}
                </Stack>
              </Stack>
            ))}
          </Stack>
          {sIdx < DEMO_PRESETS.length - 1 && (
            <Divider style={{ margin: '4px 0' }} />
          )}
        </Stack>
      ))}
    </Stack>
  )
}
